import moment from 'moment';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import {useNavigate} from 'react-router-dom';

import Avatar from "@mui/material/Avatar";
import {Stack, Typography, Divider, Badge, Grid} from '@mui/material';

import CustomBox from '../common/CustomBox';
import MessageItem from './MessageItem';
import config from '../../config/config';
import './MessageListItem.scss';


const MessageListItem = props => {
  const {user} = props;
  const navigate = useNavigate();
  const displayUser = get(props, 'displayUser');
  const today = moment();
  const sentDate = moment(get(props, 'message.date_sent'));
  let patientId = get(props, 'message.user_from.patient.id');
  if (!patientId) patientId = get(props, 'message.user_to.patient.id');
  let providerId = get(props, 'message.user_from.provider.id');
  if (!providerId) providerId = get(props, 'message.user_to.provider.id');
  const onClick = () => (
    user.is_patient
    ? navigate(`/clients/messages/${providerId}`)
    : navigate(`/providers/patients/messages/${patientId}`)
  );
  return (
    <CustomBox className='MessageListItem' onClick={onClick}
      item
      xs={12}
      md='auto'
      margin={'0 0 12px 0'}
      alignContent={'center'}
      padding={'11px 10px'}
    >
      <Grid item xs={12} md='auto' padding={'0 8px'}>
        <Badge sx={{width: '100%'}} badgeContent={props.count} color='secondary'>
          <Stack className='item'
            color={config().colors.text}
            width={'100%'}
            paddingRight={'9px'}
            spacing={{md: "9px", xs: 0}}
            alignItems={{xs: 'flex-start', sm: 'center'}}
            flexDirection={{xs: 'column', sm: 'row'}}
            divider={<Divider orientation="vertical" flexItem/>}
          >
            <Stack className='item-left-side' spacing={0.5}
              sx={{
                minWidth: { xs: '100%', sm: '14.375rem' },
                maxWidth: { xs: '100%', sm: '14.375rem' }
              }}
            >
              <Stack direction="row" spacing={1} alignItems='center'>
                <Avatar
                  alt='Avatar'
                  src="/images/person.png"
                  color={'red'}
                  sx={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: 'transparent' }}
                />
                <Typography className='item-left-side__user-name' textAlign="left" variant='largeSemiBoldTight'
                            noWrap>
                  {displayUser.first_name} {displayUser.last_name}
                </Typography>
              </Stack>
              <Typography 
                className='item-left-side__datetime'
                variant='xSmallSemiBoldLooseInter'
                paddingRight='8px'
                textAlign={{ xs: 'left', sm: 'right' }}
              >
                <Typography component="span" variant='xSmallSemiBoldLooseInter'>
                  {
                    today.format('M/DD/yyyy') === sentDate.format('M/DD/yyyy')
                      ? 'Today'
                      : sentDate.format('MMM D, yyyy')
                  }
                </Typography>
                <Typography component="span" variant='xSmallSemiBoldLooseInter'>
                  {sentDate.format('h:mm a')}
                </Typography>
              </Typography>
            </Stack>
            <Stack alignItems="left" className='item-right-side'
                   textAlign='left'
                   width={'100%'}
                   sx={{
                     paddingRight: {xs: 0, sm: '24px'},
                     paddingLeft: {xs: 0, sm: '8px'},
                   }}
            >
              {/* <Typography 
                className='default-font__medium item-right-side__text-multiple-line' 
                variant='normal500TightInter'
                style={{whiteSpace: 'pre-line'}}
                noWrap={false}
              >
                <span style={{fontWeight: '700'}}>{props?.message?.user_from?.id === user.id ? 'You: ' : 'Them: '}</span>
                {get(props, 'message.message')}
              </Typography> */}
              <MessageItem
                message={get(props, 'message')}
                wasSentByMe={props?.message?.user_from?.id === user.id}
              />
            </Stack>
          </Stack>
        </Badge>
      </Grid>
    </CustomBox>
  );
};

MessageListItem.propTypes = {
  message: PropTypes.object,
};

export default MessageListItem;
